import ProjectTextBlocksVisualStore from './ProjectTextBlocksVisualStore';
import { RootStores } from '../../common/stores';
import { STORE_PROJECT_TEXT_BLOCKS } from '../constants';
import { STORE_PROJECTS_ROOT_UI } from '../../common/constants';

export { default as ProjectTextBlocksVisualStore } from './ProjectTextBlocksVisualStore';

export function injectListLabelsStores(obj: RootStores) {
    obj[STORE_PROJECT_TEXT_BLOCKS] = new ProjectTextBlocksVisualStore(obj[STORE_PROJECTS_ROOT_UI]);
}

export type ListTextBlocksStores = {
    [STORE_PROJECT_TEXT_BLOCKS]?: ProjectTextBlocksVisualStore;
};
